import isInIframe from '../../../@Future/Util/Iframe/IsInIframe';

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const isInMacAndSafariAndIframe = isSafari && isInIframe();